




























import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import markdownit from 'markdown-it';

@Component
export default class Projects extends Vue {
    @Inject() private resume!: Resume;
    private renderMarkdown(text: string) {
        return markdownit().render(text);
    }
}
